





































































import Vue from "vue";
import { onMounted, ref } from "@vue/composition-api";
import { UseLoading } from "@/common/composition/loading";
import { UseModal } from "@/components/root/modal";
import { clone, debounce } from "@/fp";
import {
  get_risky_event_report_config,
  set_risky_event_report_config,
} from "./data/api";
import {
  DEFAULT_RISKY_EVENT_REPORT_CONFIG,
  RiskyEventReportConfig,
} from "./data/model";

import { UseDropdownItems } from "@/common/composition/dropdown-items";
import EmailListModalVue from "./EmailListModal.vue";
import ScheduledButtons from "./ScheduledButtons.vue";
import { trackReportEvent } from "../data/report-analytics";
export default Vue.extend({
  components: { ScheduledButtons },
  setup() {
    const [days, selected_day, set_selected_day] = UseDropdownItems(
      ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"].map((day) => ({
        name: day,
        id: day,
      })),
      () => {
        console.log("day selected");
      }
    );
    const [is_loading, set_loading] = UseLoading(false).as_arr();

    const current_email = ref("");

    const create_config_clone = (config: RiskyEventReportConfig) => {
      return clone(config);
    };

    const risky_event_report_config = ref(
      create_config_clone(DEFAULT_RISKY_EVENT_REPORT_CONFIG)
    );
    const last_saved_config = ref(
      create_config_clone(DEFAULT_RISKY_EVENT_REPORT_CONFIG)
    );

    const open_email_list_modal = async () => {
      const res = await UseModal().show(EmailListModalVue, {
        emails: risky_event_report_config.value.recipients,
      });
      if (res.type == "success") {
        // @ts-ignore
        risky_event_report_config.value.recipients = res.msg;
        update_config();
      }
    };

    const remove_email = async (email: string) => {
      const res = await UseModal().showSimple({
        title: "Remove Email",
        desc: "Are you sure you want to remove this email?",
        cancelBtnText: "Cancel",
        submitBtnText: "Remove",
        is_destructive: true,
      });
      if (res.type == "success") {
        const { recipients } = risky_event_report_config.value;
        const new_recipients = recipients.filter((r) => r != email);
        risky_event_report_config.value.recipients = new_recipients;
        update_config();
      }
    };

    const toggle_on_off = (value: "none" | "weekly") => {
      if (value == "none") {
        toggle_off();
      } else {
        toggle_on();
      }
    };

    const toggle_on = async () => {
      const res = await UseModal().showSimple({
        title: "Turn On Weekly Report",
        desc: "Are you sure you want to turn on the weekly report?",
        submitBtnText: "Turn On",
        cancelBtnText: "Cancel",
        is_destructive: false,
      });
      if (res.type == "success") {
        risky_event_report_config.value.isActive = true;
        update_config();
      }
    };

    const toggle_off = async () => {
      const res = await UseModal().showSimple({
        title: "Turn Off Weekly Report",
        desc: "Are you sure you want to turn off the weekly report?",
        submitBtnText: "Turn Off",
        cancelBtnText: "Cancel",
        is_destructive: true,
      });
      if (res.type == "success") {
        risky_event_report_config.value.isActive = false;
        update_config();
      }
    };

    const update_config = debounce(250)(async () => {
      set_loading(true);
      const {
        severities,
        isActive,
        recipients,
      } = risky_event_report_config.value;
      // @ts-ignore
      const res = await set_risky_event_report_config({
        severities,
        isActive,
        recipients,
      });
      if (res.success) {
        const previous = last_saved_config.value;
        trackReportEvent(
          !previous.isActive && res.value.isActive
            ? "scheduled"
            : previous.isActive && !res.value.isActive
            ? "schedule_deleted"
            : "schedule_updated",
          {
            report_name: "Weekly Threat Report",
            report_type: "scheduled",
            report_subtype: "risky_events",
            entity_type: "incidents",
            parameters: {
              severities: res.value.severities,
              period_type: res.value.periodType,
              scheduled_day_of_week: res.value.scheduledDayOfWeek,
            },
            schedule: {
              cadence: res.value.isActive ? "weekly" : "none",
              recipient_count: res.value.recipients.length,
            },
            source: "weekly_threat_report",
          }
        );
        risky_event_report_config.value = res.value;
        last_saved_config.value = create_config_clone(res.value);
      }
      set_loading(false);
    });

    onMounted(async () => {
      set_loading(true);
      const res = await get_risky_event_report_config();
      if (res.success) {
        risky_event_report_config.value = res.value;
        last_saved_config.value = create_config_clone(res.value);
      }
      set_loading(false);
    });

    return {
      is_loading,
      days,
      selected_day,
      set_selected_day,
      risky_event_report_config,
      current_email,
      update_config,
      toggle_on_off,
      remove_email,
      open_email_list_modal,
    };
  },
});
